import React, {useState, useEffect} from 'react';
import HeaderUserIcons from '../HeaderUserIcons';
import MobileHeaderIcons from './mobileHeader/MobileHeaderIcons';
import Breadcrumbs from './breadcrumbs/Breadcrumbs';
import NextGenerationIcon from '../../../../../assets/icons/next-generation-EU.png';

function Header(): JSX.Element {
    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 1160);

    useEffect(() => {
        const handleResize = (): void => {
            setIsMobile(window.innerWidth <= 1160);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <header className="c-header">
            <img src={NextGenerationIcon} alt="NextGenerationEU" className="c-header__euLogo" />
            <div className="c-header__divider">&bull;</div>
            <Breadcrumbs />
            <div className="c-header__spacer" />
            <div className="c-header__content">
                <div className="c-header__content_icons">{isMobile ? <MobileHeaderIcons /> : <HeaderUserIcons theme="dark" />}</div>
            </div>
        </header>
    );
}

export default Header;
